import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconReceiptBill: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="receipt-bill, purchase, invoice"><path d="M8.75 7.75H15.25M8.75 11.75H11.25M4.75 2.75H19.25V21L16.6667 19L14.3333 21.25L12 19L9.66667 21.25L7.33333 19L4.75 21V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconReceiptBill;
